exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".care-team-tasks--2lRfh4M27baotcZLSIZODE {\n  display: flex;\n  flex-direction: column;\n}\n", ""]);

// exports
exports.locals = {
	"notesFieldContainer": "care-team-tasks--2lRfh4M27baotcZLSIZODE",
	"notesFieldContainer": "care-team-tasks--2lRfh4M27baotcZLSIZODE"
};